import { createContext } from 'react'

export const ConfigPrevetiviContext = createContext({})
export const ConfigPlannerContext = createContext({})
